import { useEffect, RefObject } from "react";

export default function useClickOutSideComponent(
  ref: RefObject<Element | null>,
  handler: () => void
) {
  const clickHandler = (e: Event) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      handler();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", clickHandler);

    return () => {
      document.removeEventListener("mousedown", clickHandler);
    };
  }, [ref]);
}
